var map = {
	"./add.svg": 302,
	"./alert.svg": 303,
	"./back.svg": 304,
	"./edit.svg": 305,
	"./fav-active.svg": 306,
	"./fav-inactive.svg": 307,
	"./fav.svg": 308,
	"./info.svg": 309,
	"./navbar-active.svg": 310,
	"./navbar.svg": 311,
	"./phone.svg": 312,
	"./photo.svg": 313,
	"./remove.svg": 314,
	"./search.svg": 315,
	"./spinner.svg": 316,
	"./status-past.svg": 317,
	"./text.svg": 318,
	"./user.svg": 319,
	"./warning.svg": 320
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 301;


//////////////////
// WEBPACK FOOTER
// ./src/img/icons ^\.\/.*\.svg$
// module id = 301
// module chunks = 0